/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';

import Dropdown, { DropdownField, DropdownProps } from '../Dropdown';
import ImageUpload, {
  ImageUploadField,
  ImageUploadProps,
} from '../ImageUpload';
import TextInput, { TextInputField, TextInputProps } from '../TextInput';

export type Field = {
  onChange: (value: string) => void;
  staticProperties: DropdownField | ImageUploadField | TextInputField;
  value?: string;
};

type FieldsProps = {
  /** A list of fields of various types. */
  fields: Array<Field>;
};

function isDropdown(field: Field): field is DropdownProps {
  return (field as DropdownProps).staticProperties.type === 'dropdown';
}

function isImageUpload(field: Field): field is ImageUploadProps {
  return (field as ImageUploadProps).staticProperties.type === 'image';
}

function isTextInput(field: Field): field is TextInputProps {
  return (field as TextInputProps).staticProperties.type === 'text';
}

const rootCss = css`
  display: grid;
  grid-gap: 30px;
  margin: '15px 0px';
`;

/**
 * Renders a list of fields of various types. Picks which component to render
 * each field with given the field's type.
 */
const Fields = ({ fields }: FieldsProps) => {
  return (
    <div css={rootCss}>
      {fields.map((field, i) => {
        if (isDropdown(field)) {
          return <Dropdown {...field} key={i} />;
        } else if (isImageUpload(field)) {
          return <ImageUpload {...field} key={i} />;
        } else if (isTextInput(field)) {
          return <TextInput {...field} key={i} />;
        }
        return null;
      })}
    </div>
  );
};

export default Fields;
